<div class="wrapper" *ngIf="item">
  <div class="title" [routerLink]="['/', 'liste', item.numero_immeuble]">
    <div class="line-1">{{ item.nom_immeuble }}</div>
    <div class="line-2">
      {{ formatTitle(item) }}
    </div>
    <div class="line-3">{{ item.direction_immobiliere_nom }}</div>
  </div>
  <div class="line-4">
    Numéro de l'immeuble :
    <strong>
      {{ item.numero_immeuble }}-{{ item.type_propriete_ou_location }}</strong
    >
  </div>
  <div class="line-5">
    Vocation officielle: <strong>{{ item.vocation_officielle }}</strong>
  </div>
  <div class="line-6">
    Type :
    <strong>{{
      item.type_propriete_ou_location === 'P' ? 'Propriété' : 'Location'
    }}</strong>
  </div>
</div>
